import { jsxs, jsx } from "react/jsx-runtime";
import { ToggleCard, Box, Icon, Text } from "@zillow/constellation-10";
import { useRef } from "react";
const Tile = ({
  href,
  // Aliased so it doesn't shadow the imported constellation Icon wrapper.
  Icon: SelectedIcon,
  IconOutline,
  onClick,
  selected = false,
  target = "_blank",
  title
}) => {
  const RenderedIcon = selected ? SelectedIcon : IconOutline;
  const linkRef = useRef(null);
  return /* @__PURE__ */ jsxs(
    ToggleCard,
    {
      "aria-label": title,
      css: {
        position: "relative",
        // v8 padding { default: 'sm', md: 'lg' }: v8 `default` = base
        //   (applies below 481px, i.e. mobile), plain `md` = min-width 481px
        //   (tablet-up/desktop). sm = 16px (default), lg = 32px (looser).
        //   Panda mobile-first: base = mobile value, md (480px) = desktop value.
        padding: {
          base: "default",
          md: "looser"
        }
      },
      onClick: () => {
        var _a;
        if (href) (_a = linkRef.current) == null ? void 0 : _a.click();
        else onClick == null ? void 0 : onClick();
      },
      selected,
      children: [
        href ? /* @__PURE__ */ jsx(Box, { asChild: true, css: {
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0
        }, children: /* @__PURE__ */ jsx("a", { ref: linkRef, href, target, "aria-label": title, onClick: () => onClick == null ? void 0 : onClick() }) }) : null,
        /* @__PURE__ */ jsxs(Box, { css: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }, children: [
          /* @__PURE__ */ jsx(Icon, { size: "xl", css: {
            marginBlockEnd: "tighter"
          }, children: /* @__PURE__ */ jsx(RenderedIcon, {}) }),
          selected ? (
            // v8 selected: { default: 'finePrintHeading', md: 'bodyHeading' }
            //   mobile (<481px) = finePrintHeading (10px bold),
            //   >=481px = bodyHeading (16px bold). Bold throughout; only size scales.
            //   Panda mobile-first: base = 10px, md (480px) = 16px.
            /* @__PURE__ */ jsx(Text, { textStyle: "body-bold", css: {
              textAlign: "center",
              fontSize: "fineprint",
              lineHeight: "fineprint",
              md: {
                fontSize: "body",
                lineHeight: "body"
              }
            }, children: title })
          ) : (
            // v8 unselected: { default: 'finePrint', md: 'body' }
            //   mobile (<481px) = finePrint (10px regular),
            //   >=481px = body (16px regular). Panda mobile-first: base = 10px, md = 16px.
            /* @__PURE__ */ jsx(Text, { textStyle: "body", css: {
              textAlign: "center",
              fontSize: "fineprint",
              lineHeight: "fineprint",
              md: {
                fontSize: "body",
                lineHeight: "body"
              }
            }, children: title })
          )
        ] })
      ]
    }
  );
};
export {
  Tile as default
};
